import { ISortedPlanificationActivity } from '@sdk/contracts';
import { useLocation, useNavigate } from 'react-router-dom';

import { DetailsWrapper, InfoWrapper, ItemWrapper, TextWrapper } from './TaskCard.styles';

import { Icon } from '@/components/Icon';
import { PartItemTag } from '@/components/PartItemTag';
import { isActivityCompleted, buildCourseUrl } from '@/utils';

interface TaskCardProps {
  task: ISortedPlanificationActivity;
}

export const TaskCard: React.FC<TaskCardProps> = ({ task }) => {
  const navigateTo = useNavigate();
  const { pathname } = useLocation();
  const isCompleted = isActivityCompleted(task.activity?._id, task.subscription);

  const planItemId = `${task.activity?._id}-${task.partIndex}`;

  const handleActivityClick =
    (activityId: string, subscriptionId: string, _planItemId?: string) => () => {
      navigateTo(
        buildCourseUrl({
          subscriptionId,
          activityId,
          planItemId: _planItemId,
          fromPath: pathname,
          isPlanificationFlow: true
        })
      );
    };

  const getIcon = () => {
    if (isCompleted) {
      return <Icon i="CheckmarkFilled" color={'green6'} size={20} />;
    }
    return <Icon i="CircleDash" color={'black6'} size={20} />;
  };

  if (!task.activity || !task.subscription) return null;
  return (
    <ItemWrapper
      onClick={handleActivityClick(task.activity?._id, task.subscription?._id, planItemId)}>
      {getIcon()}
      <InfoWrapper>
        <TextWrapper $isCompleted={!!isCompleted}>
          {task.activity?.name}
          <PartItemTag partIndex={task.partIndex} partsTotal={task.partsTotal} />
        </TextWrapper>
        <DetailsWrapper>
          {task.activity?.type} · {task.subscription?.course?.name}
        </DetailsWrapper>
      </InfoWrapper>
    </ItemWrapper>
  );
};
